var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.28571 8H22.7143C23.4214 8 24 8.675 24 9.5C24 10.325 23.4214 11 22.7143 11H1.28571C0.578571 11 0 10.325 0 9.5C0 8.675 0.578571 8 1.28571 8Z",
    fill: "#6A798B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28571 0H22.7143C23.4214 0 24 0.675 24 1.5C24 2.325 23.4214 3 22.7143 3H1.28571C0.578571 3 0 2.325 0 1.5C0 0.675 0.578571 0 1.28571 0Z",
    fill: "#6A798B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.28571 16H22.7143C23.4214 16 24 16.675 24 17.5C24 18.325 23.4214 19 22.7143 19H1.28571C0.578571 19 0 18.325 0 17.5C0 16.675 0.578571 16 1.28571 16Z",
    fill: "#6A798B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.e82cdedadbd5c20555e06d28d4bd5c7d.svg";
export { ForwardRef as ReactComponent };